import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import Button from 'antd/lib/button';
import Tooltip from 'antd/lib/tooltip';
import Typography from 'antd/lib/typography';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { SECONDARY_COLOR } from '../../theme';
import { getProgramNameFromSource } from '../../domain/event/getProgramNameFromSource';
import { MemoizedDatetimePopover } from '../datetimePopover/datetimePopover';
import { useEarliestEventInBatchQuery } from '../../domain/event-analytic/queries';

interface ITableTitleProps {
    batchId?: string;
    companyId?: number;
}

export const EventAnalyticGroupedBySiteTableTitle: React.FC<ITableTitleProps> = ({ batchId, companyId }) => {
    const navigate = useNavigate();

    const {
        data: record,
        isLoading,
        isError,
    } = useEarliestEventInBatchQuery(
        {
            batchId: batchId!,
            companyId,
        },
        {
            enabled: !!batchId,
            retry: false,
        }
    );

    const formattedDate = useMemo(() => {
        if (!record) return <></>;

        return (
            <MemoizedDatetimePopover
                timestamp={new Date(record.event_datetime_start).valueOf()}
                timeZone={record.site?.site_timezone}
                inline={true}
            />
        );
    }, [record]);

    const returnToAllBatchStatistics = () => {
        navigate(-1);
    };

    return (
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <Tooltip title="Back to all events">
                <Button size="small" shape="circle" icon={<ArrowLeftOutlined />} onClick={returnToAllBatchStatistics} style={{ marginTop: 4 }} />
            </Tooltip>

            {!isLoading && record && (
                <Typography.Title level={4} style={{ marginTop: 0, color: SECONDARY_COLOR, textAlign: 'center' }}>
                    Analytic for event <span style={{ color: 'black' }}>{formattedDate}</span> by sites.
                    <br />
                    Duration: <span style={{ color: 'black' }}>{record?.event_duration} minutes. </span>
                    Program: <span style={{ color: 'black' }}>{getProgramNameFromSource(record?.event_source || '')}.</span>
                </Typography.Title>
            )}
            {(isLoading || isError || !record) && (
                <Typography.Title
                    level={4}
                    style={{
                        marginTop: 0,
                        color: SECONDARY_COLOR,
                        textAlign: 'center',
                    }}
                >
                    {isLoading ? 'Loading...' : 'No data'}
                </Typography.Title>
            )}

            <div></div>
        </div>
    );
};
